import React from "react";
import { Link } from "react-router-dom";
import { STATIC_SERVER_URL } from "../../../config/config";
import AsyncImage from "components/shared/AsyncImage/AsyncImage";

import "./productlist-item.scss";

function ProductListItem({ id, item_no, name, price, discount_price, coupons }) {
  return (
    <div className="product-card col-6 col-md-4 col-lg-3">
      <Link to={`/termek/${id}`} className="product-card__link">
        {coupons.length > 0 && (
          <div className="product-card__coupon-badges">
            <img
              src={`${STATIC_SERVER_URL}/web/images/shop/coupons/${coupons[0].coupon_badge}`}
              alt="kupon"
              className="product-card__coupon-badge"
            />
          </div>
        )}
        <figure className={discount_price ? "discount" : ""}>
          <AsyncImage
            src={`${STATIC_SERVER_URL}/web/images/shop/products/${id}_001.png`}
            alt={name}
          />
          <div className="line" />
        </figure>
        <h3>{name}</h3>
        <div className="text-center">
          {!!discount_price && (
            <>
              <p className="price">Akciós ár: {discount_price.toLocaleString()} Ft</p>
              <p className="original_price">Eredeti ár: {price.toLocaleString()} Ft</p>
            </>
          )}
          {!discount_price && <p className="price">Ár: {price.toLocaleString()} Ft</p>}
        </div>
      </Link>
    </div>
  );
}

export default ProductListItem;
